const translations = {
  en: {
    attendanceManagement: "Attendance Management",
    attendanceSubtitle: "Monitor and manage employee attendance",
    infoText:
      "Overtime and tardiness are calculated based on client settings",
    filtersActions: "Filters & Actions",
    showing: "Showing",
    of: "of",
    records: "records",
    searchEmployee: "Search Employee",
    typeEmployeeName: "Type employee name...",
    statusFilter: "Status Filter",
    allStatuses: "All statuses",
    presentOnly: "Present Only",
    absentOnly: "Absent Only",
    lateOnly: "Late Only",
    onLeave: "On Leave",
    restDay: "Rest Day",
    holiday: "Holiday",
    halfDay: "Half Day",
    selectDate: "Select Date",
    refresh: "Refresh",
    recalculating: "Recalculating...",
    exportCSV: "Export CSV",
    exportTemplate: "Export Template",
    dailyAttendance: "Daily Attendance Records",
    all: "All",
    present: "Present",
    absent: "Absent",
    late: "Late",
    employeeID: "ID",
    employeeName: "Employee Name",
    date: "Date",
    checkIn: "Check-In",
    checkOut: "Check-Out",
    hoursWorked: "Hours Worked",
    status: "Status",
    overtime: "Overtime",
    tardiness: "Tardiness",
    monthlyOvertimeTotal: "Monthly Overtime Total",
    monthlyTardinessTotal: "Monthly Tardiness Total",
    client: "Client",
    actions: "Actions",
    hours: "hours",
    resetCheckIn: "Reset check-in to",
    resetCheckOut: "Reset check-out to",
    viewHistory: "View history",
    noRecordsFound: "No Attendance Records Found",
    noRecordsMatch: "No records match the selected filters.",
    attendanceHistory: "Attendance History",
    checkInUpdated: "✅ Check-in time updated and recalculated!",
    checkOutUpdated: "✅ Check-out time updated and recalculated!",
    refreshSuccess:
      "✅ Attendance data refreshed and recalculated successfully!",
    refreshFailed: "❌ Failed to refresh attendance data",
    updateCheckInFailed: "❌ Failed to update check-in time",
    updateCheckOutFailed: "❌ Failed to update check-out time",
    noDataExport: "No data to export!",
    clearAll: "Clear All",
    dateTooOldError: "Cannot edit records older than 7 days",
    dateTooOldTooltip: "This record is older than 7 days and cannot be edited",

    // ── Overtime Requests Center ──────────────────────────────────────────
    overtimeRequests: "Overtime Requests",
    overtimeRequestsSubtitle: "Review and manage employee overtime approvals",
    pendingApproval: "Pending",
    approvedStatus: "Approved",
    rejectedStatus: "Rejected",
    allRequests: "All",
    employeeInfo: "Employee Information",
    attendanceInfo: "Attendance Information",
    overtimeInfo: "Overtime Information",
    approvalTimeline: "Approval Timeline",
    approve: "Approve",
    reject: "Reject",
    rejectionReason: "Rejection Reason",
    rejectionReasonPlaceholder: "Please provide a reason for rejection...",
    addNotes: "Add Notes (Optional)",
    notesPlaceholder: "Add any comments or notes...",
    confirmApproval: "Are you sure you want to approve this overtime request?",
    confirmRejection: "Are you sure you want to reject this overtime request?",
    noOvertimeRequests: "No Overtime Requests",
    noOvertimeDescription: "There are no overtime requests to review at this time.",
    backToList: "Back to List",
    requestCreated: "Request Created",
    managerApproval: "Manager Approval",
    adminApproval: "Admin Approval",
    manager: "Manager",
    admin: "Admin",
    department: "Department",
    position: "Position",
    scheduledShift: "Scheduled Shift",
    actualCheckIn: "Actual Check-In",
    actualCheckOut: "Actual Check-Out",
    breakDuration: "Break Duration",
    totalWorkedHours: "Total Worked Hours",
    shiftEndTime: "Shift End Time",
    actualEndTime: "Actual End Time",
    overtimeDuration: "Overtime Duration",
    overtimeReason: "Overtime Reason",
    minutes: "min",
    hour: "h",
    pendingCount: "pending",
    approving: "Approving...",
    rejecting: "Rejecting...",
    overtimeApprovedSuccess: "Overtime approved successfully",
    overtimeRejectedSuccess: "Overtime rejected successfully",
    reasonRequired: "Rejection reason is required",
    approvalSavedTitle: "Approval saved",
    approvalSavedManager: "Manager approval recorded successfully. The request is now waiting for the final admin review.",
    approvalSavedAdmin: "Admin approval recorded successfully. The request is moving toward final processing.",
    rejectionSavedTitle: "Request rejected",
    rejectionSavedManager: "Manager rejection recorded. The request is now closed.",
    rejectionSavedAdmin: "Admin rejection recorded. The request will not continue further.",
    allowanceWarningTitle: "Approval saved",
    allowanceWarningMessage: "The approval has been recorded successfully.",
    approvalErrorTitle: "Action could not be completed",
    approvalErrorMessage: "The overtime approval could not be completed for this request.",
    rejectionErrorTitle: "Rejection could not be completed",
    rejectionErrorMessage: "The overtime rejection could not be completed for this request.",
  },
  ar: {
    attendanceManagement: "نظام إدارة الحضور",
    attendanceSubtitle: "مراقبة وإدارة حضور الموظفين",
    infoText:
      "يتم حساب الوقت الإضافي والتأخير بناءً على إعدادات العميل المحددة",
    filtersActions: "الفلاتر والإجراءات",
    showing: "عرض",
    of: "من",
    records: "سجل",
    searchEmployee: "البحث عن موظف",
    typeEmployeeName: "اكتب اسم الموظف...",
    statusFilter: "فلتر الحالة",
    allStatuses: "جميع الحالات",
    presentOnly: "الحاضرون فقط",
    absentOnly: "الغائبون فقط",
    lateOnly: "المتأخرون فقط",
    onLeave: "في إجازة",
    restDay: "يوم راحة",
    holiday: "عطلة رسمية",
    halfDay: "نصف يوم",
    selectDate: "اختر التاريخ",
    refresh: "تحديث",
    recalculating: "جارٍ إعادة الحساب...",
    exportCSV: "تنزيل CSV",
    exportTemplate: "تنزيل القالب",
    dailyAttendance: "سجلات الحضور اليومية",
    all: "الكل",
    present: "حاضر",
    absent: "غائب",
    late: "متأخر",
    employeeID: "رقم الموظف",
    employeeName: "اسم الموظف",
    date: "التاريخ",
    checkIn: "تسجيل الدخول",
    checkOut: "تسجيل الخروج",
    hoursWorked: "ساعات العمل",
    status: "الحالة",
    overtime: "وقت إضافي",
    tardiness: "تأخير",
    monthlyOvertimeTotal: "إجمالي الوقت الإضافي الشهري",
    monthlyTardinessTotal: "إجمالي التأخير الشهري",
    client: "العميل",
    actions: "الإجراءات",
    hours: "ساعة",
    resetCheckIn: "إعادة تعيين الدخول إلى 10:00",
    resetCheckOut: "إعادة تعيين الخروج إلى 18:00",
    viewHistory: "عرض السجل",
    noRecordsFound: "لم يتم العثور على سجلات حضور",
    noRecordsMatch: "لا توجد سجلات تطابق الفلاتر المحددة.",
    attendanceHistory: "سجل الحضور",
    checkInUpdated: "✅ تم تحديث وقت الدخول وإعادة الحساب!",
    checkOutUpdated: "✅ تم تحديث وقت الخروج وإعادة الحساب!",
    refreshSuccess: "✅ تم تحديث بيانات الحضور وإعادة حسابها بنجاح!",
    refreshFailed: "❌ فشل تحديث بيانات الحضور",
    updateCheckInFailed: "❌ فشل تحديث وقت الدخول",
    updateCheckOutFailed: "❌ فشل تحديث وقت الخروج",
    noDataExport: "لا توجد بيانات للتصدير!",
    clearAll: "مسح الكل",
    dateTooOldError: "لا يمكن تحرير السجلات الأكثر من 7 أيام",
    dateTooOldTooltip: "هذا السجل أقدم من 7 أيام ولا يمكن تعديله",

    // ── Overtime Requests Center ──────────────────────────────────────────
    overtimeRequests: "طلبات الوقت الإضافي",
    overtimeRequestsSubtitle: "مراجعة وإدارة موافقات الوقت الإضافي للموظفين",
    pendingApproval: "قيد الانتظار",
    approvedStatus: "معتمد",
    rejectedStatus: "مرفوض",
    allRequests: "الكل",
    employeeInfo: "معلومات الموظف",
    attendanceInfo: "معلومات الحضور",
    overtimeInfo: "معلومات الوقت الإضافي",
    approvalTimeline: "مسار الموافقات",
    approve: "اعتماد",
    reject: "رفض",
    rejectionReason: "سبب الرفض",
    rejectionReasonPlaceholder: "يرجى تقديم سبب للرفض...",
    addNotes: "إضافة ملاحظات (اختياري)",
    notesPlaceholder: "أضف أي تعليقات أو ملاحظات...",
    confirmApproval: "هل أنت متأكد من اعتماد طلب الوقت الإضافي هذا؟",
    confirmRejection: "هل أنت متأكد من رفض طلب الوقت الإضافي هذا؟",
    noOvertimeRequests: "لا توجد طلبات وقت إضافي",
    noOvertimeDescription: "لا توجد طلبات وقت إضافي للمراجعة في الوقت الحالي.",
    backToList: "العودة للقائمة",
    requestCreated: "تم إنشاء الطلب",
    managerApproval: "موافقة المدير",
    adminApproval: "موافقة الإدارة",
    manager: "المدير",
    admin: "الإدارة",
    department: "القسم",
    position: "المنصب",
    scheduledShift: "الوردية المجدولة",
    actualCheckIn: "وقت الدخول الفعلي",
    actualCheckOut: "وقت الخروج الفعلي",
    breakDuration: "مدة الاستراحة",
    totalWorkedHours: "إجمالي ساعات العمل",
    shiftEndTime: "وقت انتهاء الوردية",
    actualEndTime: "وقت الانتهاء الفعلي",
    overtimeDuration: "مدة الوقت الإضافي",
    overtimeReason: "سبب الوقت الإضافي",
    minutes: "دقيقة",
    hour: "س",
    pendingCount: "قيد الانتظار",
    approving: "جارٍ الاعتماد...",
    rejecting: "جارٍ الرفض...",
    overtimeApprovedSuccess: "تم اعتماد الوقت الإضافي بنجاح",
    overtimeRejectedSuccess: "تم رفض الوقت الإضافي بنجاح",
    reasonRequired: "سبب الرفض مطلوب",
    approvalSavedTitle: "تم حفظ الموافقة",
    approvalSavedManager: "تم تسجيل موافقة المدير بنجاح. الطلب الآن في انتظار موافقة الإدارة النهائية.",
    approvalSavedAdmin: "تم تسجيل موافقة الإدارة بنجاح. الطلب الآن في طريقه إلى الإكمال النهائي.",
    rejectionSavedTitle: "تم تسجيل الرفض",
    rejectionSavedManager: "تم تسجيل رفض المدير بنجاح. تم إغلاق الطلب الآن.",
    rejectionSavedAdmin: "تم تسجيل رفض الإدارة. لن يستمر الطلب في المسار التالي.",
    allowanceWarningTitle: "تم حفظ الموافقة",
    allowanceWarningMessage: "تم تسجيل الموافقة بنجاح.",
    approvalErrorTitle: "تعذر إكمال الإجراء",
    approvalErrorMessage: "تعذر اعتماد طلب الوقت الإضافي لهذا الطلب.",
    rejectionErrorTitle: "تعذر إكمال الرفض",
    rejectionErrorMessage: "تعذر رفض طلب الوقت الإضافي لهذا الطلب.",
  },
};

export default translations;